import axios from 'axios';
import { authService } from './authService';

// API isolada para notificações - nunca deve quebrar o app
const NOTIFICATIONS_API_URL = import.meta.env.VITE_NOTIFICATIONS_API_URL || 'https://notifications.agendario.com.br/api';

// Criar instância isolada do Axios
const notificationsApi = axios.create({
  baseURL: NOTIFICATIONS_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 5000, // 5s timeout para não travar o app
});

// Interceptor de request - adiciona token JWT apenas se válido
notificationsApi.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    
    // Validar se o token existe e não está expirado
    if (token && authService.isTokenValid()) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (token) {
      // Token existe mas está expirado - limpar localStorage
      console.warn('[Notifications] Token expirado, removendo...');
      authService.removeToken();
      // Não adicionar Authorization header com token inválido
    } else {
      console.warn('[Notifications] Nenhum token disponível');
    }
    
    return config;
  },
  (error) => {
    console.warn('[Notifications] Request error:', error.message);
    return Promise.reject(error);
  }
);

// Interceptor de response - apenas loga erros, não redireciona
notificationsApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.warn('[Notifications] Response error:', error.response?.status || error.message);
    return Promise.reject(error);
  }
);

export default notificationsApi;
